import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import { RenderCallerDetailsStyled } from "./render-caller-details.styles";
import { RenderCallerDetailsProps } from "../../../../types/types";

import phoneOngoing from "../../../../assets/imgs/phone-ongoing.gif";
import outGoingInGoingCall from "../../../../assets/imgs/ingoing-outgoing.gif";
import { AsYouType } from "libphonenumber-js";
import {
  IncomingCallIcon,
  IncomingMissbellIcon,
  OutgoingCallIcon,
  ReturnedCallIcon,
} from "../../../../assets/svgComponents";
interface PhoneStatusIconProps {
  type: "ongoing" | "outgoing" | "incoming" | "missed" | "returned" | string;
  isOutgoing?: boolean;
  isOngoing?: boolean;
  isAnswered?: boolean;
  isReturned?: boolean;
  voicemailLeft?: boolean;
}

const typeToComponentMap: Record<PhoneStatusIconProps["type"], JSX.Element> = {
  ongoing: (
    <img
      src={phoneOngoing}
      alt="Phone Ongoing"
      className="d-block w-100 ml--7"
    />
  ),
  outgoing: <OutgoingCallIcon />,
  incoming: <IncomingCallIcon />,
  missed: <IncomingMissbellIcon />,
  returned: <ReturnedCallIcon />,
  outGoingInGoingCall: (
    <img
      src={outGoingInGoingCall}
      alt="Phone Ongoing"
      className="d-block w-100 ml--7"
    />
  ),
};

const PhoneStatusIcon: React.FC<PhoneStatusIconProps> = ({
  isOngoing,
  voicemailLeft,
  isAnswered,
  type,
  isOutgoing,
  isReturned,
}) => {
  if (isOngoing && isOutgoing)
    return typeToComponentMap.outGoingInGoingCall || null;
  if (isReturned) return typeToComponentMap.returned || null;
  else if (isOutgoing && isAnswered) return typeToComponentMap.outgoing || null;
  else if (isOngoing) return typeToComponentMap.ongoing || null;
  else if (isAnswered) return typeToComponentMap.incoming || null;
  else if (!isOngoing && !isAnswered) return typeToComponentMap.missed || null;
  else return typeToComponentMap.incoming || null;
};

const RenderCallerDetails: React.FC<RenderCallerDetailsProps> = ({
  isOngoing,
  isAnswered,
  voicemailLeft,
  type,
  contactName,
  contactPhoneNumber,
  callingTime,
  isOutgoing,
  isReturned,
}) => {
  const phoneNumber = new AsYouType("US").input("" + contactPhoneNumber);

  return (
    <RenderCallerDetailsStyled>
      <Box className="call-type">
        <PhoneStatusIcon
          type={type}
          isOngoing={isOngoing}
          isAnswered={isAnswered}
          voicemailLeft={voicemailLeft}
          isOutgoing={isOutgoing}
          isReturned={isReturned}
        />
      </Box>
      <Box>
        <Typography className="name-text">{contactName}</Typography>
        <Typography className="phone-number-text">{phoneNumber}</Typography>
        <Typography className="date-time-text">{callingTime}</Typography>
      </Box>
    </RenderCallerDetailsStyled>
  );
};

export default RenderCallerDetails;
